<h2 class="section-title">
  Testimoniale
</h2>
<section
  class="carousel-container"
  *ngIf="testimonials.length > 0"
>
  <div class="carousel">
    <div class="carousel-controllers">
      <input
        type="radio"
        name="carousel"
        [attr.id]="getSlideName(i)"
        [checked]="currentSlide == i"
        *ngFor="let testimonial of testimonials; let i = index"
        (change)="updateCurrentSlide($event, i)"
        [ngClass]="getSlideName(i) + '-controller'"
        class="carousel-radio-controller"
      />
    </div>
    <label
      [attr.for]="getSlideName(i)"
      *ngFor="let testimonial of testimonials; let i = index"
      class="carousel-item"
      [class.previous-slide]="i === previousSlide"
      [class.current-slide]="i === currentSlide"
      [class.next-slide]="i === nextSlide"
      [class.hidden-slide]="i !== previousSlide && i !== currentSlide && i !== nextSlide"
      (click)="openTestimonialModal(testimonial)"
    >
      <p class="testimonials-content">
        “{{ testimonial.content | truncate:350 }}”
      </p>
      <h5 class="testimonials-author">
        {{ testimonial.author }}
      </h5>
    </label>
  </div>
  <button
    mat-button
    (click)="getPrevious()"
    class="left-arrow"
  >
  </button>
  <button
    mat-button
    (click)="getNext()"
    class="right-arrow"
  >
  </button>
</section>


<div class="container carousel-footer">
  Noi ne dorim ce e mai bun pentru tine și familia ta, dar referința cea mai importanta rămâne părerea persoanelor care au cumparat în complexul rezidențial pe care îl dezvoltăm, în noul cartier Rahova.
</div>



// WEBPACK FOOTER //
// ./src/app/shared/testimonials-carousel/testimonials-carousel.component.html